/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TerminalTipDistributionType } from './TerminalTipDistributionType';
import {
    TerminalTipDistributionTypeFromJSON,
    TerminalTipDistributionTypeFromJSONTyped,
    TerminalTipDistributionTypeToJSON,
    TerminalTipDistributionTypeToJSONTyped,
} from './TerminalTipDistributionType';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';
import type { PaymentSplitDtoV2 } from './PaymentSplitDtoV2';
import {
    PaymentSplitDtoV2FromJSON,
    PaymentSplitDtoV2FromJSONTyped,
    PaymentSplitDtoV2ToJSON,
    PaymentSplitDtoV2ToJSONTyped,
} from './PaymentSplitDtoV2';

/**
 * 
 * @export
 * @interface InitiateAdyenTerminalPaymentV3Request
 */
export interface InitiateAdyenTerminalPaymentV3Request {
    /**
     * 
     * @type {number}
     * @memberof InitiateAdyenTerminalPaymentV3Request
     */
    amountMinorUnits: number;
    /**
     * 
     * @type {Currency}
     * @memberof InitiateAdyenTerminalPaymentV3Request
     */
    currency: Currency;
    /**
     * 
     * @type {number}
     * @memberof InitiateAdyenTerminalPaymentV3Request
     */
    executingLocationId: number;
    /**
     * 
     * @type {string}
     * @memberof InitiateAdyenTerminalPaymentV3Request
     */
    orderReference: string;
    /**
     * 
     * @type {string}
     * @memberof InitiateAdyenTerminalPaymentV3Request
     */
    paymentReference: string;
    /**
     * 
     * @type {Array<PaymentSplitDtoV2>}
     * @memberof InitiateAdyenTerminalPaymentV3Request
     */
    paymentSplits: Array<PaymentSplitDtoV2>;
    /**
     * 
     * @type {boolean}
     * @memberof InitiateAdyenTerminalPaymentV3Request
     */
    printReceipt: boolean;
    /**
     * 
     * @type {string}
     * @memberof InitiateAdyenTerminalPaymentV3Request
     */
    terminalId: string;
    /**
     * 
     * @type {string}
     * @memberof InitiateAdyenTerminalPaymentV3Request
     */
    shopperLocale?: string | null;
    /**
     * 
     * @type {TerminalTipDistributionType}
     * @memberof InitiateAdyenTerminalPaymentV3Request
     */
    terminalTipDistributionType?: TerminalTipDistributionType | null;
}



/**
 * Check if a given object implements the InitiateAdyenTerminalPaymentV3Request interface.
 */
export function instanceOfInitiateAdyenTerminalPaymentV3Request(value: object): value is InitiateAdyenTerminalPaymentV3Request {
    if (!('amountMinorUnits' in value) || value['amountMinorUnits'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('executingLocationId' in value) || value['executingLocationId'] === undefined) return false;
    if (!('orderReference' in value) || value['orderReference'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('paymentSplits' in value) || value['paymentSplits'] === undefined) return false;
    if (!('printReceipt' in value) || value['printReceipt'] === undefined) return false;
    if (!('terminalId' in value) || value['terminalId'] === undefined) return false;
    return true;
}

export function InitiateAdyenTerminalPaymentV3RequestFromJSON(json: any): InitiateAdyenTerminalPaymentV3Request {
    return InitiateAdyenTerminalPaymentV3RequestFromJSONTyped(json, false);
}

export function InitiateAdyenTerminalPaymentV3RequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiateAdyenTerminalPaymentV3Request {
    if (json == null) {
        return json;
    }
    return {
        
        'amountMinorUnits': json['amountMinorUnits'],
        'currency': CurrencyFromJSON(json['currency']),
        'executingLocationId': json['executingLocationId'],
        'orderReference': json['orderReference'],
        'paymentReference': json['paymentReference'],
        'paymentSplits': ((json['paymentSplits'] as Array<any>).map(PaymentSplitDtoV2FromJSON)),
        'printReceipt': json['printReceipt'],
        'terminalId': json['terminalId'],
        'shopperLocale': json['shopperLocale'] === undefined ? undefined : json['shopperLocale'] === null ? null : json['shopperLocale'],
        'terminalTipDistributionType': json['terminalTipDistributionType'] === undefined ? undefined : json['terminalTipDistributionType'] === null ? null : TerminalTipDistributionTypeFromJSON(json['terminalTipDistributionType']),
    };
}

export function InitiateAdyenTerminalPaymentV3RequestToJSON(json: any): InitiateAdyenTerminalPaymentV3Request {
    return InitiateAdyenTerminalPaymentV3RequestToJSONTyped(json, false);
}

export function InitiateAdyenTerminalPaymentV3RequestToJSONTyped(value?: InitiateAdyenTerminalPaymentV3Request | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amountMinorUnits': value['amountMinorUnits'],
        'currency': CurrencyToJSON(value['currency']),
        'executingLocationId': value['executingLocationId'],
        'orderReference': value['orderReference'],
        'paymentReference': value['paymentReference'],
        'paymentSplits': ((value['paymentSplits'] as Array<any>).map(PaymentSplitDtoV2ToJSON)),
        'printReceipt': value['printReceipt'],
        'terminalId': value['terminalId'],
        'shopperLocale': value['shopperLocale'],
        'terminalTipDistributionType': TerminalTipDistributionTypeToJSON(value['terminalTipDistributionType']),
    };
}

